import { FILTER_ORDER_OPTIONS } from '@/utils/filter/filterOptions';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('user', ['userChildrenAgesArrayForFilter']),
    ...mapGetters('search/filter', ['keyword', 'queryFilter']),
  },
  methods: {
    // 검색페이지: 인기 검색어 클릭
    onPopularSearchClick(keyword, from) {
      this.$router.push({
        name: 'search',
        query: {
          keyword,
          order: 'RECOMMENDATION',
          from,
        },
      });
    },
    // 검색페이지: 인기 검색어 카테고리 클릭
    onPopularSearchCategoryClick(selectedCategory) {
      this.$router.push({
        name: 'search',
        query: {
          selectedCategory,
          order: 'RECOMMENDATION',
          from:'class-by-category',
        },
      });
    },
    // 검색페이지: 키워드 검색
    onKeywordSearch(keyword) {
      this.$router.push({
        name: 'search',
        query: {
          // selectedAge: this.defaultSelectedAge(),
          order: 'RECOMMENDATION',
          ...this.$route.query,
          keyword,
          from: 'input',
        },
      });
    },
    // 검색페이지: 바텀 드로어의 '적용' 버튼 클릭
    onApplyButtonClick() {
      this.$router.push({
        name: 'search',
        query: {
          ...this.queryFilter,
          order: this.queryFilter?.order
            ? this.queryFilter?.order
            : FILTER_ORDER_OPTIONS[0].value, // POPULARITY -> 이 코드 안 쓰면 첫 검색 페이지에서 필터 적용하고 검색해도, 검색 API 호출이 안 됨.
          keyword: this.$route.query.keyword,
        },
      });
    },
    defaultSelectedAge() {
      return this.userChildrenAgesArrayForFilter?.length
        ? this.userChildrenAgesArrayForFilter.join(',')
        : undefined;
    },
  },
};
